var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"mb-4"},[_c('h1',[_vm._v(_vm._s(_vm.__('Zone bearbeiten')))])]),_vm._v(" "),_c('div',{},[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.form.put(_vm.route('admin.zones.update', _vm.zone))}}},[_c('form-fields',{attrs:{"form":_vm.form,"zone":_vm.zone}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }